module.exports = __webpack_public_path__ + "media/images/teaser-action-map-marker-2-c8ea3b20f0ab7f85ecfcded2168e1603.svg";